module.exports = __webpack_public_path__ + "static/media/a43.72f3ec0a.jpg";